/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { UsersOrderByField, OrderByDirection, UsersOrderBy } from '../apollo';

export type AdminUsersSortings = UsersOrderBy[];

export const adminUsersTableInitialSortings: AdminUsersSortings = [
  {
    Field: UsersOrderByField.DateOfSignup,
    Direction: OrderByDirection.Desc,
  },
];
